import { Outlet } from "react-router-dom";
import { SignUpContextProvider } from "@/components/organisms";
import { Login, DirectLogin, SignUpInvite, SignUp, DriverApp } from "@/components/pages";
import { DriverSignUp } from "@/components/pages/SignUp/DriverSignUp";
import { OperatorSignUp } from "@/components/pages/SignUp/OperatorSignUp";
import { RequireSignupEnabled } from "./RequireSignupEnabled";

export const authRoutes = [
  {
    path: "login-direct",
    element: <DirectLogin />,
  },
  {
    path: "login",
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: ":providerCode",
        element: <Login />,
      },
    ],
  },
  {
    path: "signup",
    element: (
      <SignUpContextProvider>
        <Outlet />
      </SignUpContextProvider>
    ),
    children: [
      {
        path: "operator",
        element: <OperatorSignUp />,
      },
      {
        element: <RequireSignupEnabled />,
        children: [
          {
            index: true,
            element: <SignUp />,
          },
          {
            path: ":providerCode",
            element: <SignUp />,
          },
          {
            path: "driver",
            element: <DriverSignUp />,
          },
          {
            path: "driver/:providerCode",
            element: <DriverSignUp />,
          },
        ],
      },
    ],
  },
  {
    path: "invite/:token",
    element: (
      <SignUpContextProvider>
        <SignUpInvite />
      </SignUpContextProvider>
    ),
  },
  {
    path: "driver-app",
    element: <DriverApp />,
  },
];
